// plugins is a alias. see client/build/webpack.base.conf.js
// import http client
import { http } from '@/plugins/http/index';
import { getData } from '@/utils/get';

export const getTableSettings = (payload = null) => http.post('apiDocumentFolder/getTableSettings', payload).then(getData);

export const get = (payload = null) => http.post('apiDocumentFolder/getRows', payload).then(getData);

export const getRow = (rowID) => http.get(`apiDocumentFolder/getRow&ID=${rowID}`).then(getData);

export const create = (row) => http.post('apiDocumentFolder/create', row).then(getData);

export const update = (row) => http.post('apiDocumentFolder/edit&ID=' + row.ID, row).then(getData);

export const remove = (row) => http.post('apiDocumentFolder/delete', row).then(getData);